import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-dropdown-search',
  templateUrl: './dropdown-search.component.html',
  styleUrls: ['./dropdown-search.component.scss'],
})
export class DropdownSearchComponent implements OnInit, OnChanges {
  constructor(private eRef: ElementRef) { }

  @Input() options: string[] = [];
  @Input() placeholderProp: string = 'Select an option';
  @Input() disabled: boolean = false;
  @Output() optionSelected = new EventEmitter<string>();

  showOptions = false;
  selectedOption: string | null = null;
  filteredOptions: string[] = [];

  ngOnInit() {
    this.filteredOptions = [...this.options];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] && !changes['options'].firstChange) {
      this.filteredOptions = [...this.options];
      this.selectedOption = null;
    }
  }

  toggleDropdown() {
    this.showOptions = !this.showOptions;
  }

  filterOptions(event: Event) {
    const value = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredOptions = this.options.filter(option =>
      option.toLowerCase().includes(value)
    );
  }

  selectOption(option: string) {
    this.selectedOption = option;
    this.optionSelected.emit(option);
    this.showOptions = false;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showOptions = false;
      this.filteredOptions = [...this.options];
    }
  }
}